





































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CourseItem, checkAuth } from '@/apis/courseList/courseList';
import i18n from '@/lang';

@Component({})
export default class CourseCell extends Vue {
  @Prop() itemData!: CourseItem;
  @Prop() disableMoreActions!: boolean;
  @Prop({default:''}) showType!: string; //'isTop' 置顶类型 //sort 排序

  get isShowMoreActions(): boolean {
    return !this.disableMoreActions;
  }

  handleCode() {
    if (this.itemData.role === 1) {
      this.$emit('itemCodeActions', this.itemData);
    }
  }

  handleMore() {
    this.$emit('itemMoreActions', this.itemData);
  }

  handleDetails(itemData: any) {
    this.$store.commit('setCourseRole', String(itemData.role));
    if (itemData.role === 0) {
      // 学生判断权限
      checkAuth(itemData.id).then(res => {
        if (res.state === 0) {
          if (res.userInfo.grade === '0') {
            res.userInfo.grade = '';
          }
          const roleobj = {
            classno: res.userInfo.classno,
            grade: res.userInfo.grade,
            enrolltime: res.userInfo.enrolltime
          };
          this.checkInfoEmit(roleobj, itemData.id);
        } else {
          window.sessionStorage.setItem('courseId', itemData.id);
          this.$router.push(`/courseHome?courseId=${itemData.id}&courseRole=${itemData.role}`);
        }
      });
    } else {
      window.sessionStorage.setItem('courseId', itemData.id);
      this.$router.push(`/courseHome?courseId=${itemData.id}&courseRole=${itemData.role}`);
    }
  }

  // 上报资料校验数据
  @Emit('check-info')
  checkInfoEmit(roleobj: any, courseId: string) {
    return {
      roleobj,
      courseId
    };
  }
  
}
